'use strict';

import GenericTableData from './GenericTableData';

let ServiceContractDetailsData = GenericTableData.getTableDataBus(
  'SERVICE_CONTRACT_DETAILS',
  'service_contract_details',
);

ServiceContractDetailsData.getServiceContractDetailsAndAssociations = (
  id,
  busListenerActionName,
) => {
  return ServiceContractDetailsData.getRecord(
    id,
    {
      _include: 'resources,documents',
    },
    true,
    busListenerActionName,
  );
};
export default ServiceContractDetailsData;
